import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from 'vue';
import CallTextBalloon from '../../../common/components/CallTextBalloon.vue';
import VButton from '../../../common/components/VButton.vue';
import { TreeOptionsBranch, TreeOptionsBranchOption } from '../../interfaces/form';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChoiceBranch',
  props: {
  branch: {
    type: Object as PropType<TreeOptionsBranch>,
    required: true,
  },
  valueChain: {
    type: Array as PropType<any[]>,
    required: true,
  },
  showCallText: {
    type: Boolean,
    default: true,
  },
},
  emits: {
  choice: (_choices: TreeOptionsBranchOption[]) => true,
},
  setup(__props, { emit }) {

const props = __props;





const value = computed(() => {
  return props.valueChain && props.valueChain[0];
});

const nextValueChain = computed(() => {
  return props.valueChain.slice(1);
});

const selectedOption = computed(() => {
  return props.branch.options.find((option) => value.value === option.value);
});

function onChoice(choice: TreeOptionsBranchOption) {
  if (value.value !== choice.value) {
    emit('choice', [choice]);
  }
}

function onBranchedChoice(choices: TreeOptionsBranchOption[]) {
  emit('choice', [selectedOption.value!, ...choices]);
}

return { __sfc: true,props, emit, value, nextValueChain, selectedOption, onChoice, onBranchedChoice, CallTextBalloon, VButton }
}

})